import { render, staticRenderFns } from "./paperDetail.vue?vue&type=template&id=85f3754c&scoped=true&"
import script from "./paperDetail.vue?vue&type=script&lang=js&"
export * from "./paperDetail.vue?vue&type=script&lang=js&"
import style0 from "./paperDetail.vue?vue&type=style&index=0&id=85f3754c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f3754c",
  null
  
)

export default component.exports